import { AuthRequiredFunction } from '@okta/okta-angular/src/okta/models/okta.config';

export class OktaSettings {
    oktaConfiguration?: OktaConfig;
}

export class OktaConfig {
    issuer?: string;
    redirectUri?: string;
    clientId?: string;
    scope?: string;
    scopes?: string[];
    responseType?: any;
    pkce?: boolean;
    onAuthRequired?: AuthRequiredFunction;
    testing?: TestingObject;
    tokenManager: {
        storage: 'sessionStorage'
    }
    // tokenManager?: TokenManagerConfig;
    // postLogoutRedirectUri?: string;
    // isAuthenticated?: IsAuthenticatedFunction;
    // onSessionExpired?: OnSessionExpiredFunction;
}

export class TestingObject {
    disableHttpsCheck = false;
}

